import { actionTypes } from "constants/types";

export const nofifyTimeManager = (data) => {
  return (dispatch) => {
    return dispatch({ type: actionTypes.NEW_TIME_ENTRY_ADDED, payload: data });
  };
};
